import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '@/lib/theme';

/** Sonner wired to the app theme and hairline surface language. */
export function Toaster(props: ToasterProps) {
  const { resolved } = useTheme();

  return (
    <Sonner
      theme={resolved}
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group rounded-md border border-hairline bg-elevated text-ink shadow-lg shadow-black/10 text-data',
          description: 'text-ink-muted',
          actionButton: 'bg-accent text-accent-ink rounded-sm',
          cancelButton: 'bg-sunken text-ink-muted rounded-sm',
          error: 'border-danger/40',
          success: 'border-success/40',
          warning: 'border-warning/40',
        },
      }}
      {...props}
    />
  );
}
